import * as React from 'react';
import { LogOut, ShieldAlert } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent } from '../../ui/card';

export interface AccessDeniedPageProps {
  /** The translated message text */
  message: string;
  /** Callback when sign-out is clicked */
  onSignOut: () => void;
  /** The translated sign-out button label */
  signOutLabel: string;
  /** The translated title text */
  title: string;
}

export function AccessDeniedPage({
  message,
  onSignOut,
  signOutLabel,
  title,
}: AccessDeniedPageProps): React.JSX.Element {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background">
      <Card className="w-full max-w-md border-0 shadow-lg">
        <CardContent className="flex flex-col items-center gap-6 p-10">
          <ShieldAlert className="size-12 text-destructive" />
          <h1 className="text-xl font-semibold">{title}</h1>
          <p className="text-center text-sm text-muted-foreground">{message}</p>
          <Button className="w-full" onClick={(): void => void onSignOut()} variant="outline">
            <LogOut className="me-2 size-4" />
            {signOutLabel}
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
